import React, { useEffect, useState } from "react";
import { Box, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import { useLocation } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import { Student_Attendace_Head } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/StudentAttendanceTableHead";
import { getTutorAttendanceView } from "../../../../../redux/features/CRDslice";

const TutorAttendanceView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const admissionNo = searchParams.get("admissionNo");
  const studentName = searchParams.get("studentName");
  const course = searchParams.get("course");
  const trainerId = searchParams.get("trainerId");
  const croId = searchParams.get("croId");

  const [value, setValue] = useState(dayjs());
  const dispatch = useDispatch();

  const { loading, tutorAttendanceView } = useSelector((state) => state.crd);

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [month, setmonth] = useState(dayjs(value).format("MM"));
  const [year, setyear] = useState(dayjs(value).format("YYYY"));

  const data = {
    page: pageNum,
    limit: gridSize,
    trainer_id: trainerId,
    cro_id: croId,
    year: year,
    month: month,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getTutorAttendanceView(data));
    }
  }, [pageNum, gridSize, year, month]);

  return (
    <GlobalWrapper title={"Trainer Attendance View"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          paddingBottom={3}
        >
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Admission No : {admissionNo}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Student Name : {studentName}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Course : {course}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#538083,#538083)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Total Sessions : 3
          </Box>
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          pb: 2,
          gap: 2,
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Month"
            value={dayjs(value)}
            onChange={(newValue) => {
              setmonth(dayjs(newValue).format("MM"));
            }}
            format="MMMM"
            views={["month"]}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Select Year"
            value={dayjs(value)}
            onChange={(newValue) => {
              setyear(dayjs(newValue).format("YYYY"));
            }}
            format="YYYY"
            views={["year"]}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Student_Attendace_Head}
          rows={tutorAttendanceView}
          meta={tutorAttendanceView?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
          actionComponent={<></>}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TutorAttendanceView;
